module.exports = __webpack_public_path__ + "img/pharmacies.2ad2a791.png";